<template>
  <div class="survey">
    <survey v-if="survey" id="surveyElement" :survey="survey"></survey>
  </div>
</template>

<script>
import * as SurveyJs from "survey-vue";
import { mapActions, mapState } from "vuex";

let Survey = SurveyJs.Survey;
SurveyJs.Survey.cssType = "bootstrap";
SurveyJs.defaultBootstrapCss.navigationButton = "btn btn-green";

export default {
  data() {
    return {
      survey: null
    };
  },
  components: {
    Survey
  },
  computed: {
    ...mapState("survey", ["survey_type", "initial_survey", "final_survey"]),
    ...mapState(["user_id", "exam_id"])
  },
  methods: {
    ...mapActions("survey", ["saveSurveyResults", "finishSurvey"])
  },

  created() {
    let survey_json = null;

    try {
      if (this.survey_type === "initial_survey") {
        survey_json = JSON.parse(this.initial_survey);
      } else if (this.survey_type === "final_survey") {
        survey_json = JSON.parse(this.final_survey);
      }
    } catch (e) {
      console.log("Error Parsing JSON :) !");
      console.log(e);
    }

    if (survey_json !== null) {
      this.survey = new SurveyJs.Model(survey_json);
    } else {
      this.finishSurvey();
    }
  },

  mounted() {
    if (this.survey !== null) {
      this.survey.onComplete.add(result => {    
          this.saveSurveyResults(result)
      });
    }
  }
};
</script>


<style>
.btn-green {
  background-color: #1ab394;
  color: #fff;
  border-radius: 3px;
}

.btn-green:focus,
.btn-green:hover {
  background-color: #18a689;
  color: #fff;
}

.panel-footer {
  padding: 0 15px;
  border: none;
  text-align: right;
  background-color: #fff;
}

.sv_qstn .sq-root {
  border: 1px solid gray;
  border-left: 4px solid #18a689;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 30px;
}

.sv_qstn .sq-root-cb {
  border-left: 4px solid orange;
}

.sq-title {
  font-size: 20px;
  margin-left: 20px;
}

.sq-title-required {
  color: red;
}

.sq-label {
  margin-left: 30px;
}

.sq-item:nth-child(1) {
  margin-bottom: 5px;
}
</style>
